"use client";

import type * as React from "react";
import { useMemo, useState } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import { BookingSearchForm } from "@/components/booking/BookingSearchForm";
import { AppDrawer } from "@/components/ui/app-drawer";
import { Button } from "@/components/ui/button";
import {
  buildBookingUrl,
  formValuesToSearchParams,
  parseBookingSearchParams,
  searchParamsToFormValues,
  type BookingSearchFormValues,
} from "@/lib/booking/search-params";
import { LucidePenLine } from "lucide-react";

export const BookingSearchEditDrawer: React.FC = () => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const [open, setOpen] = useState(false);

  const initialValues = useMemo(() => {
    const booking = parseBookingSearchParams(searchParams);
    return booking ? searchParamsToFormValues(booking) : undefined;
  }, [searchParams]);

  const handleSubmit = (values: BookingSearchFormValues) => {
    const params = formValuesToSearchParams(values);
    if (!params) {
      return;
    }

    router.push(buildBookingUrl(params));
    setOpen(false);
  };

  return (
    <AppDrawer
      direction="top"
      open={open}
      onOpenChange={setOpen}
      modal={false}
      headerMode="minimal"
      title="Edit search"
      contentClassName="data-[vaul-drawer-direction=top]:mt-0 data-[vaul-drawer-direction=top]:max-h-[90dvh] data-[vaul-drawer-direction=top]:rounded-b-2xl"
      bodyClassName="px-6 pb-8 pt-2 sm:px-10"
      trigger={
        <Button
          type="button"
          variant="ghost"
          size="icon"
          aria-label="Edit search"
        >
          <LucidePenLine/>
        </Button>
      }
    >
      <BookingSearchForm
        variant="drawer"
        initialValues={initialValues}
        onSubmit={handleSubmit}
      />
    </AppDrawer>
  );
};
